import { Sun } from '@snack-uikit/loaders';
import { ICON_POSITION } from '../../constants';
import { Variant } from './constants';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function getVariant(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    iconPosition = _ref.iconPosition;
  if (label && icon && iconPosition === ICON_POSITION.After) {
    return Variant.IconAfter;
  }
  if (label && icon && iconPosition === ICON_POSITION.Before) {
    return Variant.IconBefore;
  }
  if (label) {
    return Variant.LabelOnly;
  }
  return Variant.IconOnly;
}
export function getWrappedIcon(_ref2) {
  var icon = _ref2.icon,
    iconClassName = _ref2.iconClassName,
    loading = _ref2.loading;
  if (loading) {
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": 'loading-icon',
      className: iconClassName,
      children: /*#__PURE__*/_jsx(Sun, {
        size: "s"
      })
    });
  }
  if (icon) {
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": 'icon',
      className: iconClassName,
      children: icon
    });
  }
  return undefined;
}
export function getWrappedLabel(_ref3) {
  var label = _ref3.label,
    labelClassName = _ref3.labelClassName;
  return label ? /*#__PURE__*/_jsx("span", {
    "data-test-id": 'label',
    className: labelClassName,
    children: label
  }) : undefined;
}
export function getChildren(_ref4) {
  var icon = _ref4.icon,
    label = _ref4.label,
    iconPosition = _ref4.iconPosition,
    iconClassName = _ref4.iconClassName,
    labelClassName = _ref4.labelClassName,
    loading = _ref4.loading;
  var wrappedIcon = getWrappedIcon({
    icon: icon,
    iconClassName: iconClassName,
    loading: loading
  });
  var wrappedLabel = getWrappedLabel({
    label: label,
    labelClassName: labelClassName
  });
  switch (iconPosition) {
    case ICON_POSITION.Before:
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [wrappedIcon, wrappedLabel]
        });
      }
    case ICON_POSITION.After:
    default:
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [wrappedLabel, wrappedIcon]
        });
      }
  }
}